var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogleLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_288_14151)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.6813 15.3375C29.6813 14.35 29.5938 13.4125 29.4438 12.5H15.3188V18.1375H23.4063C23.0438 19.9875 21.9813 21.55 20.4063 22.6125V26.3625H25.2313C28.0563 23.75 29.6813 19.9 29.6813 15.3375Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3189 29.9998C19.3689 29.9998 22.7564 28.6498 25.2314 26.3623L20.4064 22.6123C19.0564 23.5123 17.3439 24.0623 15.3189 24.0623C11.4064 24.0623 8.0939 21.4248 6.9064 17.8623H1.9314V21.7248C4.3939 26.6248 9.4564 29.9998 15.3189 29.9998Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.90635 17.8629C6.59385 16.9629 6.43135 16.0004 6.43135 15.0004C6.43135 14.0004 6.60635 13.0379 6.90635 12.1379V8.27539H1.93135C0.906346 10.3004 0.318848 12.5754 0.318848 15.0004C0.318848 17.4254 0.906346 19.7004 1.93135 21.7254L6.90635 17.8629Z",
    fill: "#FBBC05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3189 5.9375C17.5314 5.9375 19.5064 6.7 21.0689 8.1875L25.3439 3.9125C22.7564 1.4875 19.3689 0 15.3189 0C9.4564 0 4.3939 3.375 1.9314 8.275L6.9064 12.1375C8.0939 8.575 11.4064 5.9375 15.3189 5.9375Z",
    fill: "#EA4335"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_288_14151"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleLogo);
export default __webpack_public_path__ + "static/media/google_logo.5beac04b649e9a6e638c1cf83c6e6d65.svg";
export { ForwardRef as ReactComponent };